import { action } from 'typesafe-actions';
import { ConsultaAgendamentosTypes, IConsultaAgendamentos, IFitroAgendamentos } from './types';

export const loadRequest = (
  filtro: IFitroAgendamentos | any,
  parceiros: any,
  codCdd: number | undefined
) =>
  action(ConsultaAgendamentosTypes.LOAD_REQUEST, {
    filtro,
    parceiros,
    codCdd,
  });
export const loadSuccess = (data: IConsultaAgendamentos[], total: {}) =>
  action(ConsultaAgendamentosTypes.LOAD_SUCCESS, { data, total });
export const loadFailure = () => action(ConsultaAgendamentosTypes.LOAD_FAILURE);

export const filterAgendamentos = (filter: IFitroAgendamentos) =>
  action(ConsultaAgendamentosTypes.FILTER_AGEMDAMEMTOS, { filter });
